
import React, { useEffect, useState } from "react";


import { useContext } from 'react';

import { ClientContext } from '../store/client-context.jsx';


import { Amplify } from 'aws-amplify';
import config from '../aws-exports';
import { get } from 'aws-amplify/api';

import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Card,
} from "@aws-amplify/ui-react";

import { useLoadingContext } from "react-router-loading";

import Cases from '../components/Cases/Cases';
import { MdOutlineCases } from "react-icons/md";

import PatientSearch from '../components/PatientSearch/PatientSearch';

import Error from '../components/Error/Error.js';

Amplify.configure(config);

function safeParseCasesResponse(rawResponse) {
    if (!rawResponse) {
        throw new Error('The cases API returned an empty response.');
    }

    const responseString = typeof rawResponse === 'string'
        ? rawResponse
        : JSON.stringify(rawResponse);

    const normalized = responseString
        .replace(/\r/g, '')
        .replace(/\n/g, '')
        .replace(/\\/g, '');

    const start = normalized.indexOf('{');
    const end = normalized.lastIndexOf('}');

    if (start >= 0 && end > start) {
        const candidate = normalized.slice(start, end + 1);

        try {
            const parsed = JSON.parse(candidate);
            if (parsed?.cases && Array.isArray(parsed.cases)) {
                return parsed;
            }
        } catch (parseError) {
            const casesCapture = normalized.match(/"cases"\s*:\s*\[([\s\S]*?)\]/);
            if (casesCapture && casesCapture[1]) {
                const recovered = `{ "cases": [${casesCapture[1]}] }`;
                const recoveredJson = JSON.parse(recovered);

                if (recoveredJson?.cases && Array.isArray(recoveredJson.cases)) {
                    return recoveredJson;
                }
            }

            throw parseError;
        }
    }

    throw new Error('The cases API response was not a valid JSON object.');
}

export default function About({ clientUser
}){

    const { selectedClient } = useContext(ClientContext);

    console.log ( 'about - clientuser=', clientUser); 

    const [isFetching, casesIsFetching] = useState(false);
    const [cases, setCases] = useState([]);
    const [error, setError] = useState();

    const [isOpen, setIsOpen] = useState(false);


    useEffect(() => {

        async function fetchCases() {

          

          casesIsFetching(true);
    
          try {

            //const response = await fetch('http://localhost:3000/places');


            const restOperation =  get({
                apiName: 'portalApi',
                path: '/portalapi',
                options: {
                  queryParams: {
                    dbquery: 'clientaccount:' + clientUser
                  }
                },
                 headers: {
                  "Content-Type": "application/json"}
               }
              );
          
        
              // 
              var response  = await restOperation.response;
             
              var respData = await response.body.json();

              console.log('respData: ', respData);
          
              
const responseText = respData?.response?.body?.response ?? '';
              const responseString = typeof responseText === 'string'
                ? responseText
                : JSON.stringify(responseText);

              console.log('GET call succeeded react- response: ', responseString);

              const testJSON = safeParseCasesResponse(responseString);

              console.log('GET call succeeded react 3: ', testJSON);

              const x = Array.isArray(testJSON?.cases) ? testJSON.cases.length : 0;
              console.log('GET call succeeded react length: ', x);

              casesIsFetching(false);

              setCases(testJSON);

          } catch (error) {
            setError({
              message:
                error.message || 'Could not fetch cases, please try again later.',
            });
          }
    
          //casesIsFetching(false);

        }
    
        fetchCases();

      }, []);
    
      if (error) {
        
            return <Error title="An error occurred!" message={error.message} />;
          }  

          function patientSearch (){

            setIsOpen(true);

          }
              
   
   return (
        <div>
        <Cases 
            cases={cases}
            title="Available Cases"
            isLoading={isFetching}
            loadingText="Fetching case data..."
            fallbackText="No cases available."
             />
         <PatientSearch cases={cases} />     
      </div>      
    );
};
